// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function accessProperty(path: string, obj: any) {
  return path.split(".").reduce((acc, cur) => acc[cur], obj);
}
